<template>
  <v-app id="map-app">
    <v-content>
      <v-container class="main-container">
        <v-row v-if="$vuetify.breakpoint.mdAndUp"
          class="header-bg search-bar" >
          <v-col
            cols="12"
            sm="12"
            md="12"
            class="inline-search"
          >
           <v-autocomplete
                v-model="select"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                :filter="filterObject"
                @input="selectSearchItem()"
                v-bind:label="$t('search_address')"
                flat
                hide-no-data
                outlined
              > 
          </v-autocomplete> 
          <v-btn
            depressed 
            color="primary"
            @click="addressSubmit()"><v-icon>mdi-magnify</v-icon>
          </v-btn>
          <div class="break" v-if="!this.connected"></div>
          <div class="connect" v-if="!this.connected">
           <a  @click="connect">{{$t('connect')}}</a>
                          <v-tooltip bottom content-class="mytooltip">
                                <template v-slot:activator="{ on }">
                                  <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                    <v-icon dark>mdi-help</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{$t('info_connection')}}</span>
                              </v-tooltip>
          </div>
          <div class="connect" v-if="this.connected">
           <a  @click="disconnect">{{$t('disconnect')}}</a></div>
            
          </v-col>
        </v-row>
        <v-row  v-if="!$vuetify.breakpoint.mdAndUp"
            class="header-bg-md search-bar" >
         
          <v-col
            cols="12"
            sm="8"
            md="6"
            class="inline-search"
          >
           <v-autocomplete
                v-model="select"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                :filter="filterObject"
                @input="selectSearchItem()"
                v-bind:label="$t('search_address')"
                flat
                hide-no-data
                outlined
              > 
          </v-autocomplete> 
          <v-btn
            depressed 
            color="primary"
            @click="addressSubmit()"><v-icon>mdi-magnify</v-icon>
          </v-btn>
          <div class="break" v-if="!this.connected"></div>
          <div class="connect" v-if="!this.connected">
           <a  @click="connect">{{$t('connect')}}</a>
           <v-tooltip bottom content-class="mytooltip">
                                <template v-slot:activator="{ on }">
                                  <v-btn class="mytooltipbtn2"  v-on="on" fab depressed  color="primary">
                                    <v-icon dark>mdi-help</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{$t('info_connection')}}</span>
                              </v-tooltip>
          </div>
           <div class="connect" v-if="this.connected"><a  @click="disconnect">{{$t('disconnect')}}</a></div>
            
          </v-col>
        </v-row>
        
      </v-container>
    </v-content>
    <info-dialog ref="infoPane" :showLoginDialog="showLoginDialog" :showContactDialog="showContactDialog"></info-dialog>
    <customaddress-dialog ref="customaddressPane" :showLoginDialog="showLoginDialog" :showContactDialog="showContactDialog"></customaddress-dialog>
    <customaddresssetup-dialog ref="customaddresssetupPane" :setCustomPosition="setCustomPosition"></customaddresssetup-dialog>
    <register-dialog ref="registerPane" :showCalculatorDialog="showCalculatorDialog" :getLastCalculation="getLastCalculation" ></register-dialog>
    <calculator-dialog ref="calculatorPane" :showQuoteRequestDialog="showQuoteRequestDialog"></calculator-dialog>
    <contact-dialog ref="contactPane" ></contact-dialog>
    <quoterequest-dialog ref="quoterequestPane"  :toggleCalculatorDialog="toggleCalculatorDialog"></quoterequest-dialog>
   
  </v-app>
</template>

<script>
import axios from 'axios'
import mapboxgl from 'mapbox-gl'
import Info from '@/components/Info'
import Register from '@/components/Register'
import Calculator from '@/components/Calculator'
import Contact from '@/components/Contact'
import QuoteRequest from '@/components/QuoteRequest'
import CustomAddress from '@/components/CustomAddress'
import CustomAddressSetup from '@/components/CustomAddressSetup'


export const HTTP = axios.create({
  baseURL: "",
  headers: {
    'Access-Control-Allow-Methods': "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    'Access-Control-Allow-Origin':'*',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
  }
})


export default {
  name: 'Index',
  components: {
    'info-dialog':Info,
    'register-dialog':Register,
    'calculator-dialog':Calculator,
    'contact-dialog':Contact,
    'quoterequest-dialog':QuoteRequest,
    'customaddress-dialog':CustomAddress,
    'customaddresssetup-dialog':CustomAddressSetup,
    },
  data () {
    return {
      map: null,
      loading: false,
      lastValue: '',
      defineNewAddress:false,
      justConnect:false,
      connected:false,
      candidates: {},
      customAddresses: [],
      zoom: 12,
      layers:[],
      items: [this.$t('other_address')],
      search: null,
      select: null,
      mapHeight: 0,
      mapDefaultHeight: 550,
      addressIcon: this.$store.icons.address,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  mounted () {
    if (this.$route.params.mapid == null){
      if (this.$route.params.locale.length > 2){
        this.$router.push({ name: 'customMap', params: { locale: 'fr', mapid:this.$route.params.locale  }})
      }else if (this.$route.params.locale.length == 2){
        this.$store.lang = this.$route.params.locale
      }
    }
    this.loadMapParameters()
    if (this.$cookies.isKey('token')){
      var token = this.$cookies.get('token')
      if (token.length > 4){
        this.$store.userToken = token
        this.checkToken()
        this.connected = false
        if (this.$store.userToken.length > 4){
          this.connected = true
          this.getLastCalculation()
          this.getCustomAddresses()
        }

      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.$i18n.locale = this.$route.params.locale
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    },
  },
  methods: {
    checkToken(){
      axios.get(this.$store.backendAPI+'users/'+this.$store.userToken)
      .then(response => {
        if (response.status == 200){
          this.$store.userToken = response.data.token
          this.$store.userEmail = response.data.email
          if (this.remember){
            this.$cookies.set('token', this.$store.userToken)
          }
        }
        console.log(response)

      })
      .catch(e => {
        console.log(e)
          this.$cookies.remove('token')
          this.$store.userToken = ''
          this.$store.userEmail = ''
      })
    },
    showInfoDialog(){
      //  = this.$refs.Legends
      if (this.defineNewAddress){
        this.defineNewAddress = false
      }
      this.$refs.infoPane.openDialog()
      this.$refs.registerPane.closeDialog()
      this.$refs.contactPane.closeDialog()
      this.$refs.calculatorPane.closeDialog()
      this.$refs.customaddresssetupPane.closeDialog()
      this.$refs.customaddressPane.closeDialog()
    },
    showContactDialog(){
      this.$refs.infoPane.closeDialog()
      this.$refs.registerPane.closeDialog()
      this.$refs.calculatorPane.closeDialog()
      this.$refs.contactPane.openDialog()
      this.querySelections()
    },
    connect(){
      this.justConnect = true
      this.showLoginDialog(true)
    },
    disconnect(){
      this.justConnect = false
      this.connected = false
      this.$store.lastCalculation = null
      this.$store.lastCalculationMarker = null
      this.$store.userToken = ''
      this.$store.userEmail = ''
      this.$cookies.remove('token')
      this.$store.mapMarker.remove()
      this.customAddresses  = {}
      this.$store.searchedAddress = ''
      this.$store.searchedAddressText = ''
      this.select = ''
      this.$store.mapMarker = null
      this.querySelections(this.select)

    },
    getLastCalculation(){
      var data = {} 
      data['token'] = this.$store.userToken
      data['lang'] = this.$store.lang
      axios.post(this.$store.backendAPI+'lastcalculation/', data,{
      headers: {
              // remove headers
            }
          })
      .then(response => {
        if (response.status == 200){
          if (response.data.calculation){
            console.log(response)
            this.$store.lastCalculation = response.data.data
            this.$store.lastCalculation.id = response.data.output.id
            this.$store.lastCalculation.lng = parseFloat(this.$store.lastCalculation.lng)
            this.$store.lastCalculation.lat = parseFloat(this.$store.lastCalculation.lat)
            setTimeout(() => {this.setLastCalculationMarkerPosition()}, 700)
            
          }else{
            this.$store.lastCalculation = null
          }
        }
        console.log(response)

      })
      .catch(e => {
        console.log(e)         
      })
    },
    getCustomAddresses(){
      var data = {} 
      data['token'] = this.$store.userToken
      data['lang'] = this.$store.lang
      axios.post(this.$store.backendAPI+'customaddresses/', data)
      .then(response => {
        if (response.status == 200){
          if (response.data.addresses){
            console.log(response)
            this.customAddresses = response.data.addresses

            for (var i=0; i < this.customAddresses.length; i++){
              console.log(this.customAddresses[i].address)
              this.items.push(this.customAddresses[i].address)
            }
            
          }else{
            this.customAddresses  = {}
          }
        }
        console.log(response)

      })
      .catch(e => {
        console.log(e)         
      })
    },
    showLoginDialog(loginFirst=false){
      this.$refs.customaddressPane.closeDialog()
      if (this.$store.userToken.length > 4){
        this.checkToken()
      }
      if (this.$store.userToken.length > 4){
        this.connected = true
        if (!this.defineNewAddress && !this.justConnect){
          this.showCalculatorDialog()
        }
      }else{
        this.connected = false
        this.$router.push({ name: 'register', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
        this.$refs.infoPane.closeDialog()
        this.$refs.registerPane.openDialog()
        if (loginFirst){
          this.$refs.registerPane.login()
        }
      }
    },
    showCalculatorDialog(){
      if (this.$store.userToken.length > 4){
        this.connected = true
        this.getCustomAddresses()
      }
      if (this.defineNewAddress || this.justConnect){
        this.$refs.infoPane.closeDialog()
        this.$refs.customaddressPane.closeDialog()
        this.$refs.registerPane.closeDialog()
        if (this.justConnect){
          this.justConnect = false
        }

      }else{
        this.$router.push({ name: 'estimate', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
        this.$refs.infoPane.closeDialog()
        this.$refs.registerPane.closeDialog()
        this.$refs.calculatorPane.openDialog()
      }
    },
    showQuoteRequestDialog(){
      this.$router.push({ name: 'estimate', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
      this.$refs.infoPane.closeDialog()
      this.$refs.registerPane.closeDialog()
      this.$refs.calculatorPane.closeDialog()
      this.$refs.quoterequestPane.openDialog()

    },
    toggleCalculatorDialog(){
      this.$router.push({ name: 'estimate', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
      this.$refs.infoPane.closeDialog()
      this.$refs.registerPane.closeDialog()
      this.$refs.calculatorPane.toggleDialog()
    },
    filterObject(item, queryText='', itemText='') {
      // console.log("filtering objects")
      queryText = itemText
      itemText = queryText
      // console.log(item, queryText,itemText)
      return true
    },
    loadMapParameters () {
      if (this.$route.params.mapid != null){
        this.$store.mapid = this.$route.params.mapid
      }
      var url = this.$store.backendAPI+'map/' + this.$store.mapid
      if ( this.$store.mapid.length > 1){
        url = url + '/'+this.$store.lang
      }else{
        url = url + this.$store.lang
      }
      axios.get(url)
      .then(response => {
        this.$store.mapParameters = response.data
        if (this.$store.mapParameters.hash != this.$store.mapid){
          console.log("we have a shortcut")
          this.$store.mapid = this.$store.mapParameters.hash
        }
        this.createMap()
        this.handleResize()
      })
      .catch(e => {
        console.log(e)
      })

    },
    querySelections (v) {
      console.log("query selection")
      this.loading = true
      if (v.length == 0){
        this.items = []
        this.candidates = {}
        this.items.push(this.$t('other_address'))
        this.loading = false
        return
      }
      this.lastValue = v
      var formattedAddress = encodeURIComponent(v).replace(/%20/g, '+')
      var requestURL = this.$store.mapbox_geocoding+ formattedAddress+'.json?types=address,locality,place&country=CH&access_token='+this.$store.mapboxAccessToken
      console.log(requestURL)
      axios.get(requestURL)
      .then(response => {
        var results = response.data.features
        this.items = []
        this.candidates = {}
        for(var i=0;i<results.length;i++){
          if (results[i].relevance > 0.6){
          this.items.push(results[i].place_name.replace(", Switzerland", ""))
          this.candidates[results[i].place_name.replace(", Switzerland", "")]= results[i]
          }
        }
        this.items.push(this.$t('other_address'))
        for (i=0; i < this.customAddresses.length; i++){
          console.log(this.customAddresses[i].address)
        this.items.push(this.customAddresses[i].address)
        }
        this.loading = false
      })
      .catch(e => {
        console.log(e)
      })
    },
    setCustomPosition(){
      this.defineNewAddress = false
      this.justConnect = false
      this.$refs.customaddresssetupPane.closeDialog()
      this.$refs.customaddressPane.closeDialog()
      this.select = this.$store.searchedAddress

      this.map.flyTo({
        center: [this.$store.position[0], this.$store.position[1]], zoom: this.$store.zoom
      })
      this.setMapMarkerPosition()
      this.$refs.infoPane.openDialog()
    },
    setMapMarkerPosition(){
      if (this.$store.mapMarker != null) {
        this.$store.mapMarker.remove()
      }
      var el = document.createElement('div');
      el.className = 'marker';
      this.$store.mapMarker = new mapboxgl.Marker(el)
      this.$store.mapMarker.setLngLat(this.$store.position).addTo(this.$store.map)
      this.$store.mapMarker.getElement().addEventListener('click',(e) => {
        console.log("marker clicked")
        e.stopPropagation()
        this.$store.dialog = true
        this.$refs.infoPane.openDialog()
      })
      // } else {
      //   this.$store.mapMarker.setLngLat(this.$store.position)
      // }
    },
    setLastCalculationMarkerPosition(){
      var position = []
      
       if (this.$store.lastCalculation != null && this.$store.mapMarker == null) {
          position = [this.$store.lastCalculation.lng, this.$store.lastCalculation.lat]
          var el = document.createElement('div');
          el.className = 'marker';
          this.$store.mapMarker = new mapboxgl.Marker(el)
          this.$store.mapMarker.setLngLat(position).addTo(this.$store.map)
          this.$store.mapMarker.getElement().addEventListener('click',(e) => {
            e.stopPropagation()
            this.showCalculatorDialog()
            this.$refs.calculatorPane.openExisitingCalculation(this.$store.lastCalculation)
          })
      }else{
        this.$store.lastCalculationMarker = null
      }
    },
    selectSearchItem () {
      console.log("coucou "+this.select)
      if (this.items.includes(this.select) ){
        this.addressSubmit()
      }

    },
    addressSubmit () {
      var location = []
      if (this.select == this.$t('other_address')){
        this.defineNewAddress = true
        this.$refs.customaddressPane.openDialog()
      }
      if (this.customAddresses){
        for (var i = 0; i< this.customAddresses.length; i++){
          if (this.customAddresses[i].address == this.select){
            this.$store.searchedAddress = this.customAddresses[i].address.replace(',','<br>')
            this.$store.searchedAddressText = this.customAddresses[i].address
            location = [this.customAddresses[i].lng, this.customAddresses[i].lat]
            this.$store.position = [location[0], location[1]]
            this.$store.zoom = 16
            this.checkDisponibilities(location[0], location[1])
            this.map.flyTo({
              center: [location[0], location[1]], zoom: this.$store.zoom
            })
            this.setMapMarkerPosition()
            return
          }
        }
      }
      var position = this.candidates[this.select]
      if (position === undefined || position === null)
        return
      this.$store.searchedAddress = this.select.replace(',','<br>')
      this.$store.searchedAddressText = this.select
      location = position.geometry.coordinates
      this.$store.position = [location[0], location[1]]
      this.$store.zoom = 16

      this.checkDisponibilities(location[0], location[1])
      this.map.flyTo({
        center: [location[0], location[1]], zoom: this.$store.zoom
      })
      this.setMapMarkerPosition()
      

    },
    checkDisponibilities(lng, lat){
      var requestURL = this.$store.backendAPI+'map/'+this.$store.mapParameters.id+'/availabilities/'+lng+'/'+lat +'/'
      console.log(requestURL)
      axios.get(requestURL)
      .then(response => {
        console.log(response)
        if (response.data[0] == true && response.data[1].length > 1){
          this.$store.mapZone =response.data[1]
          this.$store.dialog = true
        }else{
          this.$store.mapZone = ''
          this.$store.dialog = true
        }
        this.$refs.infoPane.openDialog()

      })
      .catch(e => {
        console.log(e)
        this.$store.mapZone = ''
        this.$store.dialog = true
        this.$refs.infoPane.openDialog()
      })

    },
    showCustomAddressSetupDialog(){
      this.$refs.customaddresssetupPane.openDialog()
    },
    createMap () {
      mapboxgl.accessToken = this.$store.mapboxAccessToken
      // init the map
      var mapstyle = 'mapbox://styles/notil/'+this.$store.mapParameters.mapboxid
      this.map = new mapboxgl.Map({
        container: 'map',
        style: mapstyle,
        // 'mapbox://styles/notil/ck3ukqyi632o41dod7qb5lzax',
        // style: 'mapbox://styles/notil/cjwm1m0om4hxq1co8uaawa33v',
        center: [this.$store.mapParameters.centerX, this.$store.mapParameters.centerY],
        zoom: this.$store.mapParameters.zoom,
        attributionControl: false
      })
      this.$store.position = [this.$store.mapParameters.centerX, this.$store.mapParameters.centerY]
      var mapNav = new mapboxgl.NavigationControl({
        showCompass: false
      })
      this.map.addControl(mapNav, 'bottom-right')
      this.$store.map = this.map

      this.map.on('load', () => {
        this.loadLayers()
        // this.loadRoadWorks()
      })
      this.map.on('mouseup', () => {
        // this.$store.position = this.map.getCenter()
        console.log("new coordinates: "+this.$store.position)
      })
      this.map.on('click', (e) => {
        var coordinates = e.lngLat.wrap()
        this.$store.position = [coordinates.lng, coordinates.lat]
        console.log("Click: "+this.$store.position)
        console.log(coordinates)
        console.log(coordinates.lng)
        if (this.defineNewAddress){
          setTimeout(() => {this.showCustomAddressSetupDialog()}, 400)
          return
        }
        var requestURL = this.$store.mapbox_geocoding+coordinates['lng']+','+coordinates['lat'] +'.json?types=address&country=CH&access_token='+this.$store.mapboxAccessToken
        console.log(requestURL)
        axios.get(requestURL)
        .then(response => {
          console.log(response)
          var results = response.data.features
          this.items = []
          this.candidates = {}
          for(var i=0;i<results.length;i++){
            if (results[i].relevance > 0.6){
            this.items.push(results[i].place_name.replace(", Switzerland", ""))
            this.candidates[results[i].place_name.replace(", Switzerland", "")]= results[i]
            }
          }
          if (results.length > 0){
            this.select = results[0].place_name.replace(", Switzerland", "")
            this.addressSubmit()
          }
        })
        .catch(e => {
          console.log(e)
        })

      })
      this.map.on('touchend', () => {
        this.$store.position = this.map.getCenter()
        console.log("new coordinates: "+this.$store.position)
        
      })

        
    },
    loadLayers(){
      this.layers = []
      for (var i = 0; i < this.$store.mapParameters.layers.length;i++){           
            var layer = this.$store.mapParameters.layers[i]
            if (layer.active){
              console.log("adding source  "+'mapbox://notil.'+layer['layer_id'] +' as '+layer['layer_id']+'src')
              this.map.addSource(layer['layer_id']+'src', {
                type: 'vector',
                url:  'mapbox://notil.'+layer['layer_id']
              }) 
            }
      }
      // setTimeout(() => {
        var parent_layer = ''
        for (i = 0; i < this.$store.mapParameters.layers.length;i++){

          layer = this.$store.mapParameters.layers[i]
          if (parent_layer.length == 0){
            parent_layer = layer['parent_layer']
          }

          if (layer.active){
            this.$store.mapZones[layer['layer_id']] = layer
            this.layers.push(layer['layer_id'])
            console.log("adding layer "+layer['layer_id'])
            console.log(layer['opacity']+" "+layer['color']+" "+layer['minzoom']+" "+layer['maxzoom'])
            this.map.addLayer({
                id: layer['layer_id'],
                type: layer['type'],
                'source': layer['layer_id']+'src',
                // source: {
                //     type: 'vector',
                //     url: 'mapbox://notil.'+layer['layer_id'] //  Mapbox tileset Map ID
                // },
                'source-layer': layer['layer_id'], // name of tilesets
                'paint': {
                    'fill-color': layer['color'],
                    'fill-opacity': Number(layer['opacity']),
                    'fill-outline-color': layer['color']
                },
                "minzoom": Number(layer['minzoom']),
                "maxzoom": Number(layer['maxzoom']),
            },parent_layer)
            parent_layer = layer['layer_id']  
          }
        }
        // this.$store.legends.drawLegends()
      // }, 2200)    
    },
    loadRoadWorks(){
        for (var i = 0; i < this.$store.mapParameters.roadworks.length;i++){
          var layer = this.$store.mapParameters.roadworks[i]
          console.log("adding layer "+layer['layer_id'])
          this.map.addLayer({
              id: layer['layer_id'],
              type: layer['type'],
              source: {
                  type: 'vector',
                  url: 'mapbox://notil.'+layer['layer_id'] //  Mapbox tileset Map ID
              },
              'source-layer': layer['layer_id'], // name of tilesets
              'paint': {
                  'fill-color': layer['color'],
                  'fill-opacity': Number(layer['opacity']),
                  'fill-outline-color': layer['color'],
              },
              "minzoom": Number(layer['minzoom']),
              "maxzoom": Number(layer['maxzoom']),
          },layer['parent_layer']);          
        }
    },
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function (addressData, placeResultData, id) {
        console.log(addressData, placeResultData, id)
    },

    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
      var mapCanvas = document.getElementsByClassName('mapboxgl-canvas')[0]
      var mapCont = document.getElementById('map')
      mapCont.style.height = this.window.height + 'px'
      mapCanvas.style.height = this.window.height+ 'px'
      this.$store.map.resize()
       this.$store.map.flyTo({
        center:this.$store.position, zoom: this.$store.map.getZoom()
      })
    }
  }
}
</script>
